/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { NewEventReq } from '../models/new-event-req';
import { NewEventRes } from '../models/new-event-res';

@Injectable({ providedIn: 'root' })
export class CtMgrEventService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiContentMgrEventCurrentGet()` */
  static readonly ApiContentMgrEventCurrentGetPath = '/api/content-mgr/event/current';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiContentMgrEventCurrentGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiContentMgrEventCurrentGet$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<NewEventRes>> {
    const rb = new RequestBuilder(this.rootUrl, CtMgrEventService.ApiContentMgrEventCurrentGetPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<NewEventRes>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiContentMgrEventCurrentGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiContentMgrEventCurrentGet(
    params?: {
    },
    context?: HttpContext
  ): Observable<NewEventRes> {
    return this.apiContentMgrEventCurrentGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<NewEventRes>): NewEventRes => r.body)
    );
  }

  /** Path part for operation `apiContentMgrEventCurrentUpdatePost()` */
  static readonly ApiContentMgrEventCurrentUpdatePostPath = '/api/content-mgr/event/current/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiContentMgrEventCurrentUpdatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiContentMgrEventCurrentUpdatePost$Response(
    params?: {
      body?: NewEventReq
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, CtMgrEventService.ApiContentMgrEventCurrentUpdatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiContentMgrEventCurrentUpdatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiContentMgrEventCurrentUpdatePost(
    params?: {
      body?: NewEventReq
    },
    context?: HttpContext
  ): Observable<void> {
    return this.apiContentMgrEventCurrentUpdatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
